import { defineMessages } from 'react-intl';

export default defineMessages({
  isClose: {
    id: 'shop.isClose',
    defaultMessage: '本店已经打烊啦',
  },
  hdlHasCouponIsClose: {
    id: 'shop.hdlHasCouponIsClose',
    defaultMessage: '抱歉，店铺繁忙或歇业中，暂时无法接餐，送您一张代金券',
  },

  isDisable: {
    id: 'shop.isDisable',
    defaultMessage: '暂未开放该功能',
  },
  isNotAcceptOrder: {
    id: 'shop.isNotAcceptOrder',
    defaultMessage: '该店铺临时歇业',
  },
  openFlag: {
    id: 'shop.openFlag',
    defaultMessage: '营业中',
  },
  closedFlag: {
    id: 'shop.closedFlag',
    defaultMessage: '已打烊',
  },
  deliveryFlag: {
    id: 'shop.deliveryFlag',
    defaultMessage: '商家配送',
  },
  openhour: {
    id: 'shop.openhour',
    defaultMessage: '营业时间',
  },
  deliveryFee: {
    id: 'shop.deliveryFee',
    defaultMessage: '配送费{currency}{shipmentFee}',
  },
  deliveryTime: {
    id: 'shop.deliveryTime',
    defaultMessage: '送达{sendTime}分钟',
  },
  morePrivilege: {
    id: 'shop.morePrivilege',
    defaultMessage: '更多优惠',
  },
  moreInfo: {
    id: 'shop.moreInfo',
    defaultMessage: '更多信息',
  },
  info: {
    id: 'shop.info',
    defaultMessage: '商家信息',
  },
  announcement: {
    id: 'shop.announcement',
    defaultMessage: '商家公告',
  },
  tel: {
    id: 'shop.tel',
    defaultMessage: '电话',
  },
  address: {
    id: 'shop.address',
    defaultMessage: '地址',
  },
  vipPriceAvaliableTime: {
    id: 'shop.vipPriceAvaliableTime',
    defaultMessage: '会员价生效时段',
  },
  privilegeInfo: {
    id: 'shop.privilegeInfo',
    defaultMessage: '优惠信息',
  },
  notConfig: {
    id: 'shop.notConfig',
    defaultMessage: '未配置',
  },
  unknownShop: {
    id: 'shop.unknownShop',
    defaultMessage: '未知的门店',
  },
  payconfigError: {
    id: 'pay.configError',
    defaultMessage: '公众号配置错误',
  },
  payShare: {
    id: 'pay.Share',
    defaultMessage: '点击右上角分享给好友喔',
  },
  shopOpen: {
    id: 'shop.Open',
    defaultMessage: '营业中',
  },
  shopClosed: {
    id: 'shop.Closed',
    defaultMessage: '已打烊',
  },
  shoptoTable: {
    id: 'shop.toTable',
    defaultMessage: '送餐到桌',
  },
  shopgetFoods: {
    id: 'shop.getFoods',
    defaultMessage: '前台取餐',
  },
  shopstartOrderring: {
    id: 'shop.startOrderring',
    defaultMessage: '开始点餐',
  },
  shopnewOrder: {
    id: 'shop.newOrder',
    defaultMessage: '新建订单',
  },
  shopstartPaying: {
    id: 'shop.startPaying',
    defaultMessage: '开始点餐结账',
  },
  shopunLogin: {
    id: 'shop.unLogin',
    defaultMessage: '未登录',
  },
  shopwaitFotComfirm: {
    id: 'shop.waitFotComfirm',
    defaultMessage: '等待商户确认',
  },
  shoporderConfirmed: {
    id: 'shop.orderConfirmed',
    defaultMessage: '订单已确认',
  },
  shopconfirmAddDish: {
    id: 'shop.confirmAddDish',
    defaultMessage: '等待商户确认加菜',
  },
  shoporderComplete: {
    id: 'shop.orderComplete',
    defaultMessage: '订单已完成',
  },
  shopDropped: {
    id: 'shop.Dropped',
    defaultMessage: '订单被作废',
  },
  shoporderConfused: {
    id: 'shop.orderConfused',
    defaultMessage: '订单被拒绝',
  },
  shoptobePaid: {
    id: 'shop.tobePaid',
    defaultMessage: '待支付',
  },
  shopAnonymous: {
    id: 'shop.Anonymous',
    defaultMessage: '匿名用户',
  },
  shopordered: {
    id: 'shop.ordered',
    defaultMessage: '已点',
  },
  shoporderedDish: {
    id: 'shop.orderedDish',
    defaultMessage: '份菜',
  },
  shopaddDishs: {
    id: 'shop.addDishs',
    defaultMessage: '加菜',
  },
  shopgotoPay: {
    id: 'shop.gotoPay',
    defaultMessage: '去支付',
  },
  shopcheckDetail: {
    id: 'shop.checkDetail',
    defaultMessage: '查看详情',
  },
  shoplogToNext: {
    id: 'shop.logToNext',
    defaultMessage: '登录后方可进行操作噢~',
  },
  shopgoOnOrder: {
    id: 'shop.goOnOrder',
    defaultMessage: '继续点餐',
  },
  shopaddToOrder: {
    id: 'shop.addToOrder',
    defaultMessage: '一起的，加入点餐',
  },
  shopordering: {
    id: 'shop.ordering',
    defaultMessage: '正在点餐中, 是否{methodInfoOne}？',
  },
  shopopenTime: {
    id: 'shop.openTime',
    defaultMessage: '营业时间：',
  },
  shopunConfig: {
    id: 'shop.unConfig',
    defaultMessage: '未配置',
  },
  shopNull: {
    id: 'shop.Null',
    defaultMessage: '暂无',
  },
  shopremainAddress: {
    id: 'shop.remainAddress',
    defaultMessage: '还有{num}个收货地址',
  },
  shopcloseUpAddress: {
    id: 'shop.closeUpAddress',
    defaultMessage: '收起收货地址列表',
  },
  shopyourAddress: {
    id: 'shop.yourAddress',
    defaultMessage: '您的收货地址',
  },
  shopnotSearchAddress: {
    id: 'shop.notSearchAddress',
    defaultMessage: '附近没有搜索到地址',
  },
  shopNearAddress: {
    id: 'shop.NearAddress',
    defaultMessage: '附近地址',
  },
  shoplocateFailed: {
    id: 'shop.locateFailed',
    defaultMessage: '定位失败，请手动搜索地址',
  },
  shopreGet: {
    id: 'shop.reGet',
    defaultMessage: '重新获取',
  },
  shopshowAllShop: {
    id: 'shop.showAllShop',
    defaultMessage: '查看所有门店',
  },
  shopcannotGetAddress: {
    id: 'shop.cannotGetAddress',
    defaultMessage: '无法获取地址',
  },
  shopnoShopIn5km: {
    id: 'shop.noShopIn5km',
    defaultMessage: '5公里内没有门店',
  },
  shopunSetLocation: {
    id: 'shop.unSetLocation',
    defaultMessage: '或店铺未设置位置信息',
  },
  shopnoShopInfo: {
    id: 'shop.noShopInfo',
    defaultMessage: '没有相关门店信息',
  },
  shopanonymousShop: {
    id: 'shop.anonymousShop',
    defaultMessage: '匿名门店',
  },
  shopnoStoreInfo: {
    id: 'shop.noStoreInfo',
    defaultMessage: '没有相关档口信息',
  },
  shopChanging: {
    id: 'shop.Changing',
    defaultMessage: '正在切换',
  },
  shopshopList: {
    id: 'shop.shopList',
    defaultMessage: '门店列表',
  },
  shopinputShopToSearch: {
    id: 'shop.inputShopToSearch',
    defaultMessage: '请输入要搜索的门店',
  },
  shopinputStoreToSearch: {
    id: 'shop.inputStoreToSearch',
    defaultMessage: '请输入要搜索的档口',
  },
  shopscrollToLoad: {
    id: 'shop.scrollToLoad',
    defaultMessage: '滚动加载更多门店...',
  },
  shopkrySupport: {
    id: 'shop.krySupport',
    defaultMessage: '客如云提供技术支持',
  },
  shopdistributionAble: {
    id: 'shop.distributionAble',
    defaultMessage: '可配送门店:',
  },
  shopcannotDistributeShop: {
    id: 'shop.cannotDistributeShop',
    defaultMessage: '以下门店不在配送范围内',
  },
  shopcannotDistributeAddress: {
    id: 'shop.cannotDistributeAddress',
    defaultMessage: '当前配送地址不在配送范围内哟',
  },
  loadNearShopListFailed: {
    id: 'shop.loadNearShopListFailed',
    defaultMessage: '暂无法获取附近门店信息',
  },
  shoplocateFailed2: {
    id: 'shop.locateFailed2',
    defaultMessage: '定位失败，请手动选择地址',
  },
  shopnoStoreNearby: {
    id: 'shop.noStoreNearby',
    defaultMessage: '附近没有可为您服务的档口哟',
  },
  shopnoShopNearby: {
    id: 'shop.noShopNearby',
    defaultMessage: '附近没有可为您服务的门店哟',
  },
  shoplocateFailedMSG: {
    id: 'shop.locateFailedMSG',
    defaultMessage: '定位失败啦',
  },
  shopturnOff: {
    id: 'shop.turnOff',
    defaultMessage: '已关闭',
  },
  shopinputTakeOutShop: {
    id: 'shop.inputTakeOutShop',
    defaultMessage: '请输入外送门店',
  },
  shopinputSelfPick: {
    id: 'shop.inputSelfPick',
    defaultMessage: '请输入自提门店',
  },
  shopdropToLoadShop: {
    id: 'shop.dropToLoadShop',
    defaultMessage: '下拉加载更多门店...',
  },
  shopnotSearchAddressPrompt: {
    id: 'shop.notSearchAddressPrompt',
    defaultMessage: '没搜到您说的地址哟',
  },
  shopclickToChangeCity: {
    id: 'shop.clickToChangeCity',
    defaultMessage: '点我切换城市',
  },
  shopclickToLocate: {
    id: 'shop.clickToLocate',
    defaultMessage: '点击定位当前位置',
  },
  wantToJoin: {
    id: 'shop.wantToJoin',
    defaultMessage: '要加入',
  },
  sendDate: {
    id: 'shop.sendDate',
    defaultMessage: '{month}月{day}日 {startTime}开始配送',
  },
  sendDateToday: {
    id: 'shop.sendDateToday',
    defaultMessage: '{startTime}开始配送',
  },
  acceptPreOrderIng: {
    id: 'shop.acceptPreOrderIng',
    defaultMessage: '接受预定{ing}',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/shop/index.js